import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-task-view",
  "use": "icon-task-view-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\" id=\"icon-task-view\"><path d=\"M124.5 61.8H15.2V138.1H135V61.8h-10.5zm0 65.6H25.8v-55h98.6l.1 55zM163 .1h10.8v38.1H163zM163.1 118.3h10.6V200h-10.6zM124.4 0l.1 27.5H25.8V0H15.1V38.2h120V0zM25.8 200v-27.7h98.5l.1 27.7h10.7v-38.4h-120V200zM151.9 61.8h33v33h-33z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol